import { cn } from "./cn"

const FIELD_SHELL_ERROR_BORDER_STYLE = {
  borderColor: "var(--color-feedback-danger)",
} as const

function getFieldShellClassName({
  hasError,
  isActive = false,
}: {
  hasError: boolean
  isActive?: boolean
}) {
  return cn(
    "rounded-[12px] border transition-colors duration-200 ease-out",
    hasError
      ? "border-feedback-danger"
      : isActive
        ? "border-brand-primary-3"
        : "border-transparent"
  )
}

function getFieldShellErrorStyle(hasError: boolean) {
  return hasError ? FIELD_SHELL_ERROR_BORDER_STYLE : undefined
}

export { getFieldShellClassName, getFieldShellErrorStyle }
